/**
 * @class ServerResult
 * @constructor
 * @returns {ServerResult}
 */
export default function ServerResult() {
    /** @type {Object} */
    this.data;
}

/**
 * @param {Object} data
 * @returns {undefined}
 */
ServerResult.prototype.init = function(data) {
    this.data = data;
};

ServerResult.prototype.getRoundId = function() {
    return this.data["round_id"];
};

/**
 * @returns {Array|undefined}
 */
ServerResult.prototype.getLineWins = function() {
    return this.data["result"]["lineWins"];
};

/**
 * @returns {number} Index of "Zsearching" reel
 */
ServerResult.prototype.getSearchingScatter = function() {
    return this.data["result"]["gameSpecifics"]["searching"];
};

/**
 * @param {number} index
 * @returns {ServerResult|undefined}
 */
ServerResult.prototype.getFreeSpinResult = function(index) {

    if(/*!this.getFreeSpinResults() || */typeof this.data["result"]["freeSpinResults"][index] === 'undefined') {
        return;
    }

    var fsResult = new ServerResult();
    fsResult.init(this.data["result"]["freeSpinResults"][index]);

    return fsResult;

};

/**
 * @returns {Array|undefined}
 */
ServerResult.prototype.getFreeSpinResults = function() {
    if(typeof this.data["result"]["freeSpinResults"] === 'undefined') {
        return;
    }

    return this.data["result"]["freeSpinResults"];
};

ServerResult.prototype.getReelMatrixAll = function() {
    return this.data["result"]["reelMatrix"];
};

ServerResult.prototype.getReelMatrix = function(index) {
    return this.data["result"]["reelMatrix"][index];
};

ServerResult.prototype.getGameSpecifics = function() {
    return this.data["result"]["gameSpecifics"];
};

ServerResult.prototype.getShuffleSymbols = function() {
    return this.data["result"]["gameSpecifics"]["shuffleSymbols"];
};

/** @returns {number} */
ServerResult.prototype.getTotalWin = function() {
    return this.data["result"]["totalWin"];
};

/** @returns {number|undefined} */
ServerResult.prototype.getWin = function() {

    if(typeof this.data["result"]["win"] !== 'undefined') {
        return this.data["result"]["win"];
    }
};

/**
 * Returns round total win (sumarized)
 * @returns {number}
 */
ServerResult.prototype.getLinesWinTotal = function() {
    var total = 0;
    var linesWins = this.getLineWins();

    if(linesWins) {
        for(var i = 0; i < linesWins.length; i++) {
            if(typeof linesWins[i]['win'] !== 'undefined') {
                total += linesWins[i]['win'];
            }
        }
    }

    return total;
};

/** @returns {number|undefined} */
ServerResult.prototype.getFreeSpinNumber = function() {

    if(typeof this.data["result"]["freeSpinNumber"] !== 'undefined') {
        return this.data["result"]["freeSpinNumber"];
    }
};